import prettyBytes from 'pretty-bytes';
import moment from 'moment';


export function size(bytes?: number): string {
  return bytes === undefined || isNaN(bytes) ? 'N/A' : prettyBytes(bytes * 1);
}

export function datetime(dt?: number | string | Date): string {
  if (dt === undefined || dt === null) {
    return 'N/A';
  }
  let m: moment.Moment;
  if (isNaN(dt as number)) {
    m = moment(dt);
  } else {
    m = moment.unix(dt as number);
  }

  return m.format('YYYY-MM-DD HH:mm');
}

export function percent(fl?: number): string {
  if (fl === undefined || fl === null) {
    return 'N/A';
  }
  return `${Math.floor(fl * 100)}%`;
}

export function round(f?: number, decimal: number = 0) {
  if (!f || isNaN(f as number)) {
    return 'N/A';
  }
  const scale = Math.pow(10, decimal);
  return Math.round(f * scale) / scale;
}
